import './About.css';
import headshot from '../pics/headshot.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
// import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';

function About() {

    return (
        <>
            <section className='about' id='about'>
                <img src={headshot} alt="Me in the Everglades, wearing a wide brim hat and a bug net." />

                <hgroup>
                    <h2>Howdy! My name is Michael.</h2>
                    <p>Thanks for stopping by.
                        I&apos;m a Systems Administrator and semi-professional audio technician with an MA in Philosophy.
                        <br />
                        <br />
                        If you&apos;re here from the <a href="https://www.fracturemagazine.com">Fracture Magazine</a> website, welcome!
                        <br />
                        <br />
                        This site is <i>very</i> out-of-date. Feel free to check back soon as I give it some much needed care.
                    </p>
                    <br />
                    <a href='https://x.com/michaelchusetts' >
                        <FontAwesomeIcon icon={faTwitter} className='social-icon' />
                    </a>
                    <a href='https://github.com/michaellegere' >
                        <FontAwesomeIcon icon={faGithub} className='social-icon' />
                    </a>
                </hgroup>

            </section>

        </>
    );
  }

export default About;
